<template>
  <div>
    <div class="cominfo-header">企业中心
      <span>/</span><span>课程中心</span><span>/</span><span>
        <router-link to="/Company/MyCurriculum">自研课程</router-link>
      </span><span>/</span><span>新建练习题</span>
    </div>
    <div class="lxtdivall">
      <div style="margin-bottom: 25px;">
        <el-link icon="el-icon-receiving" type="success" @click="xiazai()">模板下载</el-link>
        <el-upload style="display: inline-block;margin: 0 10px;" action="/safety/kt/ktQuestions/importST.htm"
          :show-file-list="false" :on-success="handleSuccess" :on-progress="handleProgress" :data="fileParams">
          <el-link icon="el-icon-folder-opened" type="primary">导入</el-link>
        </el-upload>
        <el-link icon="el-icon-circle-plus-outline" type="primary" @click="addTi()">添加题</el-link>
      </div>

      <el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" row-key="id" border>
        <el-table-column type="index" width="55"></el-table-column>
        <el-table-column prop="cname" label="题目"></el-table-column>
        <el-table-column prop="itype" label="题型" width="100" sortable>
          <template slot-scope="scope">
            <span v-if="scope.row.itype==1">单选</span>
            <span v-if="scope.row.itype==2">多选</span>
            <span v-if="scope.row.itype==3">判断</span>
          </template>
        </el-table-column>
        <el-table-column prop="state" width="120" label="操作" align="center">
          <template slot-scope="scope">
            <el-tooltip class="item" effect="dark" content="编辑" placement="top">
              <el-button size="mini" circle type="primary" icon="el-icon-edit" @click="toDetail(scope.row)">
              </el-button>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="删除" placement="top">
              <el-button size="mini" circle type="warning" icon="el-icon-delete-solid" @click="delCurse(scope.row.id)">
              </el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination style="margin-top: 10px;text-align: right;" background @size-change="handleSizeChange"
        @current-change="handleCurrentChange" :current-page="formInline.page" :page-sizes="[10, 20, 30, 50]"
        :page-size="formInline.rows" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>

    <el-dialog :title="ruleForm.id?'编辑试题':'新增试题'" v-loading="addloading" :visible.sync="dialogVisible" width="989px"
      :append-to-body="true" :destroy-on-close="true">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm"
        style="width: 773px;margin: 20px 0px 20px 100px;text-align: left;padding-bottom: 50px;">
        <el-form-item label="题型：" prop="itype">
          <el-select v-model="ruleForm.itype" placeholder="请选择题型" style="width: 100%;">
            <el-option v-for="item in itype" :key="item.val" :label="item.text" :value="item.val"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="题目：" prop="cname">
          <el-input v-model="ruleForm.cname" placeholder="请输入题目"></el-input>
        </el-form-item>
        <el-form-item label="难度：" prop="clevel">
          <el-select v-model="ruleForm.clevel" placeholder="请选择难度类型" style="width: 100%;">
            <el-option v-for="item in clevel" :key="item.val" :label="item.text" :value="item.val"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item prop="dalists" v-if="ruleForm.itype!='3'" :key="i" v-for="(item,i) in dalists"
          :label="'选项'+(i+1)+'：'">
          <el-input v-if="i<3" :placeholder="'请输入选项'+(i+1)+'内容'" v-model="item.conts"></el-input>
          <el-input v-else :placeholder="'请输入选项'+(i+1)+'内容'" v-model="item.conts">
            <i slot="suffix" class="el-input__icon el-icon-delete-solid" @click="delXx(i)" style="cursor: pointer;"></i>
          </el-input>
        </el-form-item>
        <!-- <el-form-item v-if="ruleForm.itype!='3'&&!disabled">
          <el-button type="primary" plain @click="addXx()">添加选项</el-button>
        </el-form-item> -->

        <el-form-item label="试题答案：" v-if="ruleForm.itype=='1'"
          :rules="[{ required: true, message: '试题答案不能为空', trigger: 'blur' }]">
          <el-radio-group v-model="ruleForm.stda">
            <el-radio v-for="(item,i) in dalists" :key="i" :label="i" :value="i">{{'选项'+(i+1)}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="试题答案：" v-if="ruleForm.itype=='2'"
          :rules="[{ required: true, message: '试题答案不能为空', trigger: 'blur' }]">
          <el-checkbox-group v-model="ruleForm.stdaArr">
            <el-checkbox v-for="(item,i) in dalists" :key="i" :label="i" :value="i">{{'选项'+(i+1)}}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="试题答案：" v-if="ruleForm.itype=='3'"
          :rules="[{ required: true, message: '试题答案不能为空', trigger: 'blur' }]">
          <el-radio-group v-model="ruleForm.stda">
            <el-radio v-for="(item,i) in 2" :key="i" :label="i" :value="i">{{i==1?'对':'错'}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="试题解析：" prop="description">
          <el-input type="textarea" :rows="2" placeholder="请输入试题解析" v-model="ruleForm.description">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button type="primary" @click="handleSave">添加</el-button>
      </span>
    </el-dialog>
    <el-dialog title="题库导入中" :visible.sync="progressVisible" width="300px" center :append-to-body="true"
      :show-close="false">
      <el-progress :text-inside="true" :stroke-width="24" :percentage="progressPercent" status="success"></el-progress>
    </el-dialog>
  </div>
</template>

<script>
  import ComTiku from '../common/ComTiku.vue'
  export default {
    props: ['currentUser'],
    data() {
      return {
        progressVisible: false,
        progressPercent: 0,
        addloading: false,
        ruleForm: {
          dalists: "[]",
          stda: '',
          stdaArr: [],
          cid: '',
          description: "暂无",
          state: 1
        },
        fileParams: {},
        total: 0,
        clevel: [{
          val: 1,
          text: '简单'
        }, {
          val: 2,
          text: '一般'
        }, {
          val: 3,
          text: '困难'
        }],
        rules: {
          cname: [{
            required: true,
            message: '题目不能为空',
            trigger: 'blur'
          }],
          parentid: [{
            required: true,
            message: '类型不能为空',
            trigger: 'blur'
          }],
          clevel: [{
            required: true,
            message: '难度不能为空',
            trigger: 'blur'
          }],
          itype: [{
            required: true,
            message: '题型不能为空',
            trigger: 'blur'
          }],
          description: [{
            required: true,
            message: '试题解析不能为空',
            trigger: 'blur'
          }],
          state: [{
            required: true,
            message: '状态不能为空',
            trigger: 'blur'
          }],
          dalists: [{
            required: true,
            message: '选项内容不能为空',
            trigger: 'blur'
          }]
        },
        formInline: {
          page: 1,
          rows: 10,
          currid: ''
        },
        tableData: [],
        dialogVisible: false,
        itype: [{
          val: 1,
          text: '单选'
        }, {
          val: 2,
          text: '多选'
        }, {
          val: 3,
          text: '判断'
        }],
        dalists: [{
          conts: "",
          iscorrect: 0
        }, {
          conts: "",
          iscorrect: 0
        }, {
          conts: "",
          iscorrect: 0
        }],
        dialogTkVisible: false,
        isdelete: false
      }
    },
    methods: {
      xiazai: function() {
        window.open("http://zhaw2021.tsanquan.com/pagekt/course/tk/ktquestions.xls");
      },
      handleProgress: function(event, file, fileList) {
        this.progressPercent = event.percent;
        this.progressVisible = true;
      },
      handleSuccess: function(response, file, fileList) {
        this.progressPercent = 0;
        this.progressVisible = false;
        if (response.stat == '1') {
          this.$message.success('导入成功！');
          this.getList();
        } else {
          this.$message.error(response.message);
        }
      },
      addTi: function() {
        this.ruleForm = {
          dalists: "[]",
          stda: '',
          stdaArr: [],
          cid: this.currentUser.cid,
          description: "暂无",
          parentname: this.parentname,
          parentid: this.parentid,
          itype: 1
        };
        this.dalists = [{
          conts: "",
          iscorrect: 0
        }, {
          conts: "",
          iscorrect: 0
        }, {
          conts: "",
          iscorrect: 0
        }];
        this.dialogVisible = true;
      },
      getList: function() {
        var url = '/kt/ktQuestions/getlistPage.htm?currid=' + this.formInline.currid;
        url += '&rows=' + this.formInline.rows;
        url += '&page=' + this.formInline.page;
        url += '&cid=' + this.currentUser.cid;
        url += '&state=1';
        this.$axios.get(url).then(res => {
          var data = res.data;
          this.tableData = data.rows;
          this.total = data.total;
        });
      },
      handleSizeChange: function(size) {
        this.$set(this.formInline, 'rows', size)
      },
      handleCurrentChange: function(page) {
        this.$set(this.formInline, 'page', page)
      },
      delCurse: function(id) {
        var $this = this;
        this.$confirm('您确定要删除该试题吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {

          this.$axios.get('/kt/ktQuestions/delByState.htm?id=' + id, function() {
            this.getList()
          });

        }).catch(() => {});
      },
      // 添加选项
      addXx: function() {
        this.dalists.push({
          conts: "",
          iscorrect: 0
        });
      },
      // 删除某个选项
      delXx: function(i) {
        this.dalists.splice(i, 1);
      },
      handleSave: function() {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            this.addloading = true;
            this.$set(this.ruleForm, 'parentname', this.parentname);
            this.$set(this.ruleForm, 'parentid', this.parentid);
            this.saveTosever(this.ruleForm);
          }
        });
      },
      saveTosever: function(formData) {
        if (formData.itype == '1') {
          this.dalists.map((item, k) => {
            k == formData.stda ? this.dalists[k].iscorrect = '1' : this.dalists[k].iscorrect = '0';
            this.dalists[k].order = Number(k) + 1;
          })
        } else if (formData.itype == '2') {
          this.dalists.map((item, k) => {
            formData.stdaArr.indexOf(k) >= 0 ? this.dalists[k].iscorrect = '1' : this.dalists[k].iscorrect = '0';
            this.dalists[k].order = Number(k) + 1;
          })
        } else if (formData.itype == '3') {
          this.dalists = [{
            iscorrect: formData.stda,
            order: 1
          }]
        }
        this.$set(formData, 'dalists', JSON.stringify(this.dalists));
        this.$set(formData, 'cid', this.currentUser.cid);
        this.$set(formData, 'currid', this.$route.query.id);

        delete formData.stda;
        delete formData.stdaArr;
        var url = formData.id ? '/kt/ktQuestions/update.htm' : '/kt/ktQuestions/add.htm';
        this.$axios.post(url, this.$qs.stringify(formData))
          .then(res => {
            var data = res.data;
            if (data.stat == '1') {
              formData.id = data.data;
              this.addloading = false;
              this.ruleForm = {
                dalists: "[]",
                stda: '',
                stdaArr: [],
                cid: this.currentUser.cid,
                description: "暂无",
                parentname: this.parentname,
                parentid: this.parentid,
                itype: 1
              };
              this.dalists = [{
                conts: "",
                iscorrect: 0
              }, {
                conts: "",
                iscorrect: 0
              }, {
                conts: "",
                iscorrect: 0
              }];
              this.dialogVisible = false;
              this.getList()
            } else {
              this.$message.error(data.message);
            }
          });
      },
      // 查看详情  编辑
      toDetail: function(row) {
        this.$axios.get('/kt/ktQuestions/detail.htm?id=' + row.id).then(res => {
          this.ruleForm = res.data.data;
          this.dalists = res.data.data.dalist;
          delete this.ruleForm.dalist;
          this.ruleForm.dalists = "[]";
          if (row.itype == "1") {
            this.dalists.map((item, i) => {
              if (item.iscorrect == '1') {
                this.$set(this.ruleForm, 'stda', i);
              }
            })
          } else if (row.itype == "2") {
            var arr = [];
            this.dalists.map((item, i) => {
              if (item.iscorrect == '1') {
                arr.push(i)
              }
            });
            this.$set(this.ruleForm, 'stdaArr', arr);
          } else if (row.itype == "3") {
            this.$set(this.ruleForm, 'stda', this.dalists[0].iscorrect);
          }
          this.dialogVisible = true;
        })

      }
    },
    created: function() {
      // 获取该课程的练习题
      // this.getList();
      this.$set(this.formInline, 'currid', this.$route.query.id);
      this.$set(this.fileParams, 'currid', this.$route.query.id);

      this.parentname = sessionStorage.getItem('product_itypeName_zy');
      this.parentid = sessionStorage.getItem('product_itype_zy');
    },
    components: {
      ComTiku
    },
    watch: {
      formInline: { //深度监听，可监听到对象、数组的变化
        handler(val, oldVal) {
          this.getList();
        },
        deep: true //true 深度监听
      }
    }
  }
</script>

<style>
  .lxtdivall {
    padding: 20px;
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/company/Addtest.vue